import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import SelectAsync from 'react-select/async';

export default class EmploymentOrder extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            controllerName: 'employmentorder',
            systemModuleId: 3,
            moduleAccessStatus: 1,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.getData();
            });
    }
    getData() {
        this.httpPost("api/v1/employmentorder/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
                else {
                    window.companyId = data.global.company.id;
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.baseSalary)) this.state.data.record.baseSalary = 0;
        if (this.isBlank(this.state.data.record.familyPrice)) this.state.data.record.familyPrice = 0;
        if (this.isBlank(this.state.data.record.mariagePrice)) this.state.data.record.mariagePrice = 0;
        if (this.isBlank(this.state.data.record.homePrice)) this.state.data.record.homePrice = 0;
        if (this.isBlank(this.state.data.record.bonPrice)) this.state.data.record.bonPrice = 0;
        if (this.isBlank(this.state.data.record.extraWorkPercent)) this.state.data.record.extraWorkPercent = 0;
        if (this.isBlank(this.state.data.record.taskExtraPercent)) this.state.data.record.taskExtraPercent = 0;
        if (this.isBlank(this.state.data.record.fridayPercent)) this.state.data.record.fridayPercent = 0;
        if (this.isBlank(this.state.data.record.holidayPercent)) this.state.data.record.holidayPercent = 0;
        if (this.isBlank(this.state.data.record.hardWorkPrice)) this.state.data.record.hardWorkPrice = 0;
        if (this.isBlank(this.state.data.record.jazbPrice)) this.state.data.record.jazbPrice = 0;
        if (this.isBlank(this.state.data.record.responsePrice)) this.state.data.record.responsePrice = 0;
        if (this.isBlank(this.state.data.record.jobPrice)) this.state.data.record.jobPrice = 0;
        if (this.isBlank(this.state.data.record.workShopPrice)) this.state.data.record.workShopPrice = 0;
        if (this.isBlank(this.state.data.record.sanavatPrice)) this.state.data.record.sanavatPrice = 0;
        if (this.isBlank(this.state.data.record.otherPrice)) this.state.data.record.otherPrice = 0;
        if (this.isBlank(this.state.data.record.final)) this.state.data.record.final = 0;

        if (this.isBlank(this.state.data.record.nobatF1)) this.state.data.record.nobatF1 = 0;
        if (this.isBlank(this.state.data.record.nobatF2)) this.state.data.record.nobatF2 = 0;
        if (this.isBlank(this.state.data.record.nobatF3)) this.state.data.record.nobatF3 = 0;
        if (this.isBlank(this.state.data.record.nobatF4)) this.state.data.record.nobatF4 = 0;
        if (this.isBlank(this.state.data.record.nightPercent)) this.state.data.record.nightPercent = 0;

        this.httpPost("api/v1/employmentorder/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            contractId: this.state.data.record.contractId,
            manCompanyId: this.state.data.record.manCompanyId,
            number: parseInt(this.state.data.record.number),
            baseSalary: parseInt(this.state.data.record.baseSalary),
            familyPrice: parseInt(this.state.data.record.familyPrice),
            mariagePrice: parseInt(this.state.data.record.mariagePrice),
            homePrice: parseInt(this.state.data.record.homePrice),
            bonPrice: parseInt(this.state.data.record.bonPrice),
            extraWorkPercent: parseInt(this.state.data.record.extraWorkPercent),
            taskExtraPercent: parseInt(this.state.data.record.taskExtraPercent),
            fridayPercent: parseInt(this.state.data.record.fridayPercent),
            holidayPercent: parseInt(this.state.data.record.holidayPercent),
            hardWorkPrice: parseInt(this.state.data.record.hardWorkPrice),
            jazbPrice: parseInt(this.state.data.record.jazbPrice),
            responsePrice: parseInt(this.state.data.record.responsePrice),
            jobPrice: parseInt(this.state.data.record.jobPrice),
            workShopPrice: parseInt(this.state.data.record.workShopPrice),
            sanavatPrice: parseInt(this.state.data.record.sanavatPrice),
            otherPrice: parseInt(this.state.data.record.otherPrice),
            final: parseInt(this.state.data.record.final),
            type: this.state.data.record.type,
            dueDate: this.state.data.record.dueDate,

            mabna: this.state.data.record.mabna,
            karkard: this.state.data.record.karkard,
            nobatF1: parseFloat(this.state.data.record.nobatF1),
            nobatF2: parseFloat(this.state.data.record.nobatF2),
            nobatF3: parseFloat(this.state.data.record.nobatF3),
            nobatF4: parseFloat(this.state.data.record.nobatF4),
            nobatPercent: this.state.data.record.nobatPercent,
            nightPercent: parseFloat(this.state.data.record.nightPercent),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/employmentorders/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    itemChange(f, e) {

        if (f == "contractId") {
            this.state.data.record[f] = e.value;
            this.state.data.record.baseSalary = e.f1;
            this.state.data.record.responsePrice = e.f5;
            this.state.data.record.jazbPrice = e.f6;
            this.state.data.record.otherPrice = e.f7;
            this.state.data.record.hardWorkPrice = e.f13;
            this.state.data.record.jobPrice = e.f14;
            this.state.data.record.workShopPrice = e.f15;
            this.state.data.record['manCompanyId'] = e.manCompanyId;
        }
        else
            this.state.data.record[f] = e;

        this.updateFormula();

        this.setState({ data: this.state.data });
    }
    getYear() {
        var year = 0;
        try {
            year = parseInt(this.state.data.record.dueDate.replace("-", "/").replace("-", "/").split("/")[0]);
        } catch { }
        return year;
    }
    updateAnnualParams() {
        var year = this.getYear();
        var bonPrice = 0;
        var homePrice = 0;
        var mariagePrice = 0;
        var familyPrice = 0;

        this.state.data.salaryBase.forEach(a => {
            if (a.year == year) {
                bonPrice = a.kharobar;
                homePrice = a.maskan;
                mariagePrice = a.mariage;
                familyPrice = a.family;
            }
        })

        this.state.data.record.bonPrice = bonPrice;
        this.state.data.record.homePrice = homePrice;
        this.state.data.record.mariagePrice = mariagePrice;
        this.state.data.record.familyPrice = familyPrice;
    }
    updateFormula() {
        this.updateAnnualParams();
        var r = this.state.data.record;
        this.state.data.record.final = this.FixedPointNumber((r.baseSalary + r.familyPrice + r.mariagePrice + r.homePrice + r.bonPrice + r.hardWorkPrice + r.jazbPrice + r.responsePrice + r.jobPrice + r.workShopPrice + r.sanavatPrice + r.otherPrice), 0);
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">

                            <div className="nk-block-head">
                                <div className="nk-block-between g-3">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">صدور حکم کارگزینی</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <NavLink to="/employmentorders/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>
                                        <NavLink to="/employmentorders" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>
                                        {this.state.data.record.id != this.getDefaultGuid() && <NavLink to={"/employmentorder/preview/" + this.state.data.record.id + "/"} className="btn btn-white btn-outline-light"><em class="icon ni ni-eye"></em><span>پیش نمایش و ارسال</span></NavLink>}
                                        {this.state.data.record.id != this.getDefaultGuid() && <a onClick={e => this.getPdf(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>}
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <form method="post" onSubmit={e => this.save(e)} className="row g-gs">
                                    <div className="col-lg-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="row g-4">
                                                    <div className="col-lg-10">
                                                        <div className="form-group">
                                                            <label className="form-label">قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync
                                                                    defaultValue={this.state.data.record.contractId != this.getDefaultGuid() ? [{ value: this.state.data.record.contractId, label: "قرارداد شماره " + this.state.data.record.contractNumber + " متعلق به " + this.state.data.record.manCompanyName + " با کد ملی " + this.state.data.record.manCompanyNationalId }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب قرار داد نیروی کار برای صدور حکم"
                                                                    defaultOptions
                                                                    loadOptions={this.loadContractsOptions}
                                                                    onChange={e => this.itemChange('contractId', e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label"></label>
                                                            <div className="form-control-wrap">
                                                                <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.data.record.contractId != this.getDefaultGuid() && <div className="col-lg-9">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">میزان حقوق و مزایا</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">مزد ثابت ( مبنا ) روزانه طبق قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.baseSalary} onChange={e => this.itemChange('baseSalary', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">حق عائله مندی</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.familyPrice} onChange={e => this.itemChange('familyPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">حق تاهل</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.mariagePrice} onChange={e => this.itemChange('mariagePrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">مسکن</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.homePrice} onChange={e => this.itemChange('homePrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">بن و خواروبار</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.bonPrice} onChange={e => this.itemChange('bonPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">سختی کار روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.hardWorkPrice} onChange={e => this.itemChange('hardWorkPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده جذب روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.jazbPrice} onChange={e => this.itemChange('jazbPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده مسئولیت روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.responsePrice} onChange={e => this.itemChange('responsePrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده شغل روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.jobPrice} onChange={e => this.itemChange('jobPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">فوق العاده کارگاهی روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.workShopPrice} onChange={e => this.itemChange('workShopPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4" style={{ "display": "none" }}>
                                                        <div className="form-group">
                                                            <label className="form-label">مزد سنوات</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.sanavatPrice} onChange={e => this.itemChange('sanavatPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">سایرمزایای روزانه</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.otherPrice} onChange={e => this.itemChange('otherPrice', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4" style={{ "display": "none" }}>
                                                        <div className="form-group">
                                                            <label className="form-label">جمع حقوق و مزایای 30 روز</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.final} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.contractId != this.getDefaultGuid() && <div className="col-lg-3">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">اطلاعات حکم</h5>
                                                </div>
                                                <div className="row g-4">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">شماره حکم</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.number} onChange={e => this.itemChange('number', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ اجرا</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" maxLength="10" value={this.state.data.record.dueDate} onChange={e => this.itemChange('dueDate', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع حکم</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.type} onChange={e => this.itemChange('type', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد اضافه کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.extraWorkPercent} onChange={e => this.itemChange('extraWorkPercent', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد فوق العاده ماموریت</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.taskExtraPercent} onChange={e => this.itemChange('taskExtraPercent', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد جمعه کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.fridayPercent} onChange={e => this.itemChange('fridayPercent', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد تعطیل کاری</label>
                                                            <div className="form-control-wrap">
                                                                <NumberFormat value={this.state.data.record.holidayPercent} onChange={e => this.itemChange('holidayPercent', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد شبکاری</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.nightPercent} onChange={e => this.itemChange('nightPercent', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد نوبت کاری</label>
                                                            <div className="form-control-wrap">
                                                                <select value={this.state.data.record.nobatPercent ? "1" : "0"} onChange={e => this.itemChange('nobatPercent', (e.target.value === "1" ? true : false))} className='form-control text-center'>
                                                                    <option value="1">بله</option>
                                                                    <option value="0">خیر</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.data.record.nobatPercent && <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">صبح و عصر</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.nobatF1} onChange={e => this.itemChange('nobatF1', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {this.state.data.record.nobatPercent && <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">صبح و عصر و شب</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.nobatF2} onChange={e => this.itemChange('nobatF2', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {this.state.data.record.nobatPercent && <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">صبح و شب</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.nobatF3} onChange={e => this.itemChange('nobatF3', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {this.state.data.record.nobatPercent && <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">شب و عصر</label>
                                                            <div className="form-control-wrap">
                                                                <input type="text" value={this.state.data.record.nobatF4} onChange={e => this.itemChange('nobatF4', e.target.value)} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">شرایط کارکرد</label>
                                                            <div className="form-control-wrap">
                                                                <select value={this.state.data.record.karkard} onChange={e => this.itemChange('karkard', parseInt(e.target.value))} className='form-control text-center'>
                                                                    <option value="1">ساعتی</option>
                                                                    <option value="2">ماهانه</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">مبنای کارکرد ساعتی</label>
                                                            <div className="form-control-wrap">
                                                                <select value={this.state.data.record.mabna} onChange={e => this.itemChange('mabna', parseInt(e.target.value))} className='form-control text-center'>
                                                                    <option value="220">220</option>
                                                                    <option value="196">196</option>
                                                                    <option value="192">192</option>
                                                                    <option value="176">176</option>
                                                                    <option value="174">174</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}